export const EVENT_CATEGORY = 'Микрокредиты';
export const DEFAULT_EVENT_VALUE = 0;

export const PAGE_VIEW_GA_STATE: { title: string; path: string } = {
  title: '',
  path: '',
};
